<main class="edit-page container">

    <div class="breadcrumb-row">
        <nav class="breadcrumb">
            <a routerLink="/">HOME</a>
            <span class="separator">›</span>
            @if (user(); as u) {
                <a routerLink="/profile">{{ (u.first_name + ' ' + u.last_name).trim() || u.username }}</a>
                <span class="separator">›</span>
            }
            <span class="current">EDIT PROFILE</span>
        </nav>
    </div>

    <div class="page-header">
        <h1>EDIT PROFILE</h1>
        <p>Here you can edit information about your profile.</p>
    </div>

    <div class="form-center">

        <form [formGroup]="profileForm" #form1="ngForm">
            <div class="field-row">
                <label for="firstName">First Name</label>
                <input type="text" id="firstName" formControlName="firstName" placeholder="First name" />
            </div>
            @if (firstName?.invalid && !firstName?.pristine) {
                @if (firstName?.errors?.['required']) {
                    <div class="field-error"><app-error error="First name is required" /></div>
                }
            }

            <div class="field-row">
                <label for="lastName">Last Name</label>
                <input type="text" id="lastName" formControlName="lastName" placeholder="Last name" />
            </div>
            @if (lastName?.invalid && !lastName?.pristine) {
                @if (lastName?.errors?.['required']) {
                    <div class="field-error"><app-error error="Last name is required" /></div>
                }
            }

            <div class="field-row">
                <label for="email">Email Address*</label>
                <input type="email" id="email" formControlName="email" placeholder="name@email.com" />
                <span class="cannot-change">*Can not be changed</span>
            </div>
        </form>

        <form [formGroup]="passwordForm" #form2="ngForm">
            <div class="field-row">
                <label for="currentPassword">Current Password</label>
                <div class="password-wrapper">
                    <input [type]="showCurrentPw() ? 'text' : 'password'" id="currentPassword"
                           formControlName="oldPassword" placeholder="••••••••••••" />
                    <button type="button" class="password-toggle" (click)="showCurrentPw.set(!showCurrentPw())">
                        <fa-icon [icon]="showCurrentPw() ? faEyeSlash : faEye" />
                    </button>
                </div>
            </div>
            @if (oldPassword?.invalid && !oldPassword?.pristine) {
                @if (oldPassword?.errors?.['required']) {
                    <div class="field-error"><app-error error="Current password is required" /></div>
                }
            }

            <div class="field-row">
                <label for="newPassword">New Password</label>
                <div class="password-wrapper">
                    <input [type]="showNewPw() ? 'text' : 'password'" id="newPassword"
                           formControlName="newPassword" placeholder="••••••••••••" />
                    <button type="button" class="password-toggle" (click)="showNewPw.set(!showNewPw())">
                        <fa-icon [icon]="showNewPw() ? faEyeSlash : faEye" />
                    </button>
                </div>
            </div>
            @if (newPassword?.invalid && !newPassword?.pristine) {
                @if (newPassword?.errors?.['required']) {
                    <div class="field-error"><app-error error="New password is required" /></div>
                } @else if (newPassword?.errors?.['weakPassword']) {
                    <div class="field-error"><app-error error="Use at least 6 characters with one upper case, number and special character." /></div>
                }
            }
            @if (errorMessage()) {
                <div class="field-error"><app-error [error]="errorMessage()" /></div>
            }
        </form>

        <div class="actions-row">
            <button class="btn btn-discard" type="button" (click)="discard()">DISCARD</button>
            <div class="save-group">
                <button class="btn btn-primary" type="button"
                        [disabled]="isLoadingProfile() || isLoadingPassword()"
                        (click)="save()">
                    @if (isLoadingProfile() || isLoadingPassword()) {
                        <app-spinner />
                    } @else {
                        SAVE
                    }
                </button>
                <button type="button" class="delete-link" (click)="confirmDelete()">Delete account</button>
            </div>
        </div>

    </div>

</main>

<app-delete-account-modal />
